(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lhub-hero"] && !Shopify.designMode) return;
  try {
    
  class LhubHeroCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.lhub-hero__track');
      this.slides = Array.from(this.querySelectorAll('.lhub-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.lhub-hero__dot'));
      this.prevButton = this.querySelector('.lhub-hero__arrow--prev');
      this.nextButton = this.querySelector('.lhub-hero__arrow--next');
      this.index = 0;
      this.speed = (parseInt(this.dataset.speed, 10) || 6) * 1000;

      if (this.slides.length < 2) return;

      this.prevButton?.addEventListener('click', () => this.goTo(this.index - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    goTo(index) {
      const total = this.slides.length;
      this.index = (index + total) % total;
      this.render();
      this.start();
    }

    render() {
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
      this.slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
      });
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.goTo(this.index + 1), this.speed);
    }

    stop() {
      clearInterval(this.timer);
    }
  }

  if (!customElements.get('lhub-hero-carousel')) {
    customElements.define('lhub-hero-carousel', LhubHeroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lhub-passes-explained"] && !Shopify.designMode) return;
  try {
    
  class LhubPassesExplained extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add('is-visible');
              observer.disconnect();
            }
          });
        },
        { threshold: 0.15 }
      );

      observer.observe(this);
    }
  }

  if (!customElements.get('lhub-passes-explained')) {
    customElements.define('lhub-passes-explained', LhubPassesExplained);
  }

  } catch(e) { console.error(e); }
})();
})();
